import React from 'react';
import { UtensilsCrossedIcon, MessageCircleIcon, PackageCheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
const steps = [{
  icon: UtensilsCrossedIcon,
  title: 'Elegís tus sabores',
  text: 'Revisá el menú y escogé tus empanadas favoritas.'
}, {
  icon: MessageCircleIcon,
  title: 'Escribís por WhatsApp',
  text: 'Confirmamos disponibilidad, cantidades y precio.'
}, {
  icon: PackageCheckIcon,
  title: 'Coordinamos tu pedido',
  text: 'Definimos entrega o retiro según disponibilidad.'
}];
export function Steps() {
  return <section id="como-pedir" className="w-full scroll-mt-24 bg-cream px-4 py-16 sm:px-6 sm:py-20" data-id="element-123" data-mp="bom24syd4avb">
      <div className="mx-auto w-full max-w-6xl" data-id="element-124" data-mp="fq77zuchbow0">
        <SectionHeading title="Así de fácil es pedir" data-id="element-125" data-mp="261vdkqagy6g7" />

        <ol className="mt-10 grid gap-4 sm:grid-cols-3" data-id="element-126" data-mp="262d73f5qy6kf">
          {steps.map(({
          icon: Icon,
          title,
          text
        }, i) => <li key={title} className="rounded-2xl border border-aqua-200 bg-white p-5 shadow-soft" data-id="element-127" data-mp="2a1ck7n1mt9my" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-128" data-mp="1lcsmjxy1pngt">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-aqua-50 text-aqua-600" data-id="element-129" data-mp="1la6ezyb5n7yl">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-130" data-mp="1v22fth4mlc6i" />
                </span>
                <span className="font-display text-[11px] uppercase tracking-[0.22em] text-gold-500" data-id="element-131" data-mp="1v4eu9kb6d4et">
                  Paso {i + 1}
                </span>
              </div>
              <h3 className="mt-4 font-display text-[17px] uppercase tracking-wide text-night-900" data-id="element-132" data-mp="12f7vck7t6ct1">
                {title}
              </h3>
              <p className="mt-1.5 text-[13.5px] leading-relaxed text-muted" data-id="element-133" data-mp="1cbudh18r2prd">
                {text}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}